import { render, staticRenderFns } from "./tools.vue?vue&type=template&id=5a975c3a&scoped=true"
import script from "./tools.vue?vue&type=script&lang=js"
export * from "./tools.vue?vue&type=script&lang=js"
import style0 from "./tools.vue?vue&type=style&index=0&id=5a975c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a975c3a",
  null
  
)

export default component.exports